module.exports = __webpack_public_path__ + "media/images/cards/jcb-238fa5854fd251ba4cb82ffdc09954db.png";